import requests from '../../../../redux/reducer/requests';
import content from '../../../../redux/reducer/content';
import { useDispatch } from 'react-redux';

export default function useWishCallbacks() {
  const dispatch = useDispatch();

  return {
    sendWish: (wishData) => dispatch(requests.thunks.sendWish(wishData)),
    getWishes: () => dispatch(requests.thunks.getWishes()),
    getWishUserItems: (uid) => dispatch(requests.thunks.getWishUserItems(uid)),
    buyWishGift: (giftData) => dispatch(requests.thunks.buyWishGift(giftData)),
    getWishUserData: (uid) => dispatch(requests.thunks.getWishUserData(uid)),
    setWishDataName: (data) => dispatch(content.actions.setWishDataName(data)),
    setWishDataImage: (data) => dispatch(content.actions.setWishDataImage(data)),
    setWishDataElf: (data) => dispatch(content.actions.setWishDataElf(data)),
    setWishStep: (step) => dispatch(content.actions.setWishStep(step)),
    setWishErrorName: (data) => dispatch(content.actions.setWishErrorName(data)),
    resetWishData: (data) => dispatch(content.actions.resetWishData(data)),
    setWishSwiper: (data) => dispatch(content.actions.setWishSwiper(data)),
    setWishElfSwiper: (data) => dispatch(content.actions.setWishElfSwiper(data)),
  };
}
